export const FORGOT_PAGE = '/users/new?method=recover';
export const LOGIN_PAGE = '/users/new?method=login';
export const PHOTOS = '/photos';
export const REVIEWS = '/reviews';
export const SEARCH_API_QUERY_PARAMS =
  '?raw_json=true&seo_links=true&education=true&average_daily_pricing=true';
export const SHARE_URL_FACEBOOK = 'https://www.facebook.com/sharer/sharer.php?u={{url}}';
export const SHARE_URL_MAIL = 'mailto:?subject={{title}}&body={{description}}';
export const SHARE_URL_PINTEREST =
  'http://pinterest.com/pin/create/button/?url={{url}}&description={{title}}&media={{image}}';
export const SHARE_URL_TWITTER =
  'https://twitter.com/intent/tweet?text={{title}}&url={{url}}&via=outdoorsy';
export const SIGN_UP_PAGE = '/users/new?method=signup';
export const TOS_PAGE = '/help/outdoorsy-terms-and-conditions';
export const RV_SEARCH_PAGE = '/rv-search';
export const PERSONA_SDK_URL = 'https://cdn.withpersona.com/dist/persona-v4.5.0.js';
export const CLOUDINARY_API_URL = 'https://api.cloudinary.com/v1_1/outdoorsy/image/upload';
// Carrier strings that the Sanity-backed `fetchArticles` dispatcher parses
// for its `?slug=`, `?article-category=`, `?article-tag=`, `?search=` and
// `?orderby=` params. The hostname is no longer significant — `fetchArticles`
// only reads URL search params — but the WP path shape is preserved so the
// dispatcher contract continues to look like the old WP REST URLs.
const HELP_ARTICLES_BASE = 'https://help.outdoorsy.com/wp/v2/article';
export const ARTICLE_URL = HELP_ARTICLES_BASE;
export const ARTICLE_SLUG_URL = `${HELP_ARTICLES_BASE}?slug=`;
export const HELP_SEARCH_URL = `${HELP_ARTICLES_BASE}?search=`;

export const AFFILIATE_HAS_OFFERS = 'http://outdoorsyinc.hasoffers.com/signup';
export const AFFILIATE_AVANT_LINK = 'https://www.avantlink.com/signup/affiliate/us?merchant=15421';
export const REFERRAL_STATS = '/referrals/stats';
export const SEND_REFERRALS = '/referrals/refer';
export const CLOUDSPONGE_API = 'https://api.cloudsponge.com/widget/';
export const HELP_HERO_URL = `https://res.cloudinary.com/outdoorsy/image/upload/v1623183511/corex/help/united-states-rv-rental-sf.png`;
export const APP_DOWNLOAD = `/app-download`;
export const RENTER_IOS_LINK = `https://apps.apple.com/app/apple-store/id1443835927?pt=118352810&ct=product-banner&mt=8`;
export const RENTER_ANDROID_LINK = `https://play.google.com/store/apps/details?id=com.outdoorsy.renter&referrer=utm_source%3Doutdoorsy%26utm_campaign%3Dproduct_banner`;
export const OWNER_IOS_LINK = `https://apps.apple.com/app/apple-store/id1416795287?pt=118352810&ct=product-banner&mt=8`;
export const OWNER_ANDROID_LINK = `https://play.google.com/store/apps/details?id=com.outdoorsy.owner&referrer=utm_source%3Doutdoorsy%26utm_campaign%3Dproduct_banner`;
export const WISHLISTS_RECENTLY_SAVED = `/wishlists-recently-saved`;
export const RESET_PASSWORD = `/auth/creds/reset`;
export const EARNED_CREDITS = `/stats/earned-credits`;
export const SIGN_UP_EMAIL = '/email/signup';
export const GIFTS_URL = 'https://outdoorsy.cashstar.com/store/recipient?locale=en-us';
export const GIFT_CARDS_BALANACE_CHECKER = 'https://balance.clutch.com/outdoorsy';
export const GIFT_CARDS_HELP = 'https://outdoorsy.giftcardhelp.com/kb/en-US/gift-card-help-423874';
export const ORDER_CORPORTATE_GIFT_CARDS = 'https://totuscards.com/giftcards/outdoorsy';
export const LOCALITY_PAGE = '/locality';
export const INSURANCE_PROTECTION_PACKAGES_URL = `https://support.outdoorsy.com/hc/en-us/articles/37646881475355-Protection-Packages`;
export const CAMPGROUND_SEARCH_PAGE = '/campground-search';
export const VETERANS_DISCOUNT_URL = 'https://verifypass.com/auth/49c0ddac29';
